//-----------------------------------------------------
// -- form
//-----------------------------------------------------
export var form = function() {
	$('.elem__input-checkbox').find('[name="privacy"]').change(function(event) {
		if (!$(this).prop("checked")) {
			event.preventDefault();
		}
	});
};
